import { Store } from "vuex";
import { State } from "@/typings/store";
import { modulosPorRuta } from "./modulos";

/**
 * Abre los canales Firestore asociados a la ruta (módulos pesados).
 * Solo se abre si la ruta está en modulosPorRuta.
 */
export const openCanalesParaRuta = async (
  store: Store<State>,
  routeName: string | undefined
): Promise<void> => {
  if (!routeName) return;
  const modulos = modulosPorRuta[routeName];
  if (!modulos || modulos.length === 0) return;
  await Promise.all(
    modulos.map((nombre) =>
      store.dispatch(nombre + "/openDBChannel", {
        pathVariables: {},
        clauses: { where: [], orderBy: [] },
      })
    )
  );
};

/**
 * Cierra los canales Firestore asociados a la ruta para liberar memoria.
 */
export const closeCanalesParaRuta = async (
  store: Store<State>,
  routeName: string | undefined
): Promise<void> => {
  if (!routeName) return;
  const modulos = modulosPorRuta[routeName];
  if (!modulos || modulos.length === 0) return;
  await Promise.all(
    modulos.map((nombre) => store.dispatch(nombre + "/closeDBChannel"))
  );
};
